import { requestServise } from "@/shared";
import $api from "@/shared/http";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { CartSummaryOrderType, ChangeItemToCart } from "../../model/types";

export const fetchCartSummary = createAsyncThunk<
  { totalQuantity: number; orderType?: CartSummaryOrderType },
  CartSummaryOrderType | null,
  { rejectValue: string }
>("cart/fetchCartSummary", async (orderType, { rejectWithValue }) => {
  try {
    const url = orderType
      ? `/basket/summary?orderType=${orderType}`
      : "/basket/summary";
    const response = await $api.post(url);
    if (response.status === 200) {
      return { totalQuantity: await response.data, orderType };
    } else {
      throw new Error("Server error");
    }
  } catch (error) {
    return rejectWithValue(error.message);
  }
});

export const deleteCartItems = requestServise.deleteWithBody<{
  basketIds: string[];
}>("cart/deleteCartItems", "/basket/items");

export const changeItemQuantity = requestServise.put<{
  items: ChangeItemToCart[];
}>("cart/changeItemQuantity", "/basket");
